import { render, staticRenderFns } from "./ApprovalStatusCards.vue?vue&type=template&id=4af2eb73&scoped=true"
import script from "./ApprovalStatusCards.vue?vue&type=script&lang=js"
export * from "./ApprovalStatusCards.vue?vue&type=script&lang=js"
import style0 from "./ApprovalStatusCards.vue?vue&type=style&index=0&id=4af2eb73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2eb73",
  null
  
)

export default component.exports